import React from 'react';
import { AllInputData } from '../types/AllInputData.types';
import { CalculatedData } from '../types/CalculatedData.types';

export const CalculatedDataContext = React.createContext<CalculatedData>(
  undefined!
);
export const AllInputDataContext = React.createContext<AllInputData>(
  undefined!
);
export const SliderValuesContext = React.createContext<number[]>(undefined!);
export const SetSliderValuesContext = React.createContext<
  React.Dispatch<React.SetStateAction<number[]>>
>(undefined!);
export const UserLinkContext = React.createContext(undefined);
export const ResetSlidersContext = React.createContext(undefined);
